module.exports = __webpack_public_path__ + "fonts/b565040181b5cb311946708374f08658.txt";